module.exports = __webpack_public_path__ + "static/media/arrow_drop_down.eebf6718.svg";